export const isValidUrl = (value: string) => {
  try {
    const url = new URL(value);
    // Ensure the URL has at least one period in the hostname
    return url && url.hostname && url.hostname.indexOf(".") > -1;
  } catch {
    return false;
  }
};

export const isValidFacebook = (value: string) =>
  /^https?:\/\/facebook.com/i.test(value) ||
  /^https?:\/\/www.facebook.com/i.test(value) ||
  /^https?:\/\/m.facebook.com/i.test(value);

export const isValidInstagram = (value: string) =>
  /^https?:\/\/instagram.com/i.test(value) ||
  /^https?:\/\/www.instagram.com/i.test(value);

export const isValidX = (value: string) => /^https?:\/\/x.com/i.test(value);

export const isValidYoutube = (value: string) =>
  /^https?:\/\/youtube.com/i.test(value) ||
  /^https?:\/\/www.youtube.com/i.test(value) ||
  /^https?:\/\/youtu.be/i.test(value);

export const isValidTiktok = (value: string) =>
  /^https?:\/\/tiktok.com/i.test(value) ||
  /^https?:\/\/www.tiktok.com/i.test(value);

export const isValidPinterest = (value: string) =>
  /^https?:\/\/pinterest.com/i.test(value) ||
  /^https?:\/\/www.pinterest.com/i.test(value);

export const isValidTripAdvisor = (value: string) =>
  /^https?:\/\/www.tripadvisor.com/i.test(value) ||
  /^https?:\/\/www.tripadvisor.ca/i.test(value);
